export default __webpack_public_path__ + "static/media/ok.50d0377d.svg";